var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.07662 20.517C9.65887 20.4014 10.1937 20.1156 10.6135 19.6958L17.2311 13.0782C17.6216 12.6877 17.6216 12.0545 17.2311 11.664L12.2814 6.71422C11.8908 6.32369 11.2577 6.32369 10.8671 6.71422L4.24951 13.3318C3.82976 13.7516 3.54397 14.2865 3.42832 14.8687L2.31971 20.4499C2.18091 21.1487 2.79658 21.7644 3.49538 21.6256L9.07662 20.517Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6956 3.88579C13.305 4.27631 13.305 4.90948 13.6956 5.3L18.6453 10.2497C19.0358 10.6403 19.669 10.6403 20.0595 10.2497L20.7666 9.54264C21.9382 8.37107 21.9382 6.47157 20.7666 5.3L18.6453 3.17868C17.4737 2.00711 15.5742 2.00711 14.4027 3.17868L13.6956 3.88579Z",
    fill: "current"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1b8a9fed7ec9582810a67e0556a65736.svg";
export { ForwardRef as ReactComponent };